// -----------------  Clear -----------------
export const CLEAR_STATE = 'CLEAR_STATE';
export const CLEAR_PANEL_STATE = 'CLEAR_PANEL_STATE';
